/**
 * Words for the old LINE history card and the history room's bar (api/app/line_link.py → Thai for staff).
 * Pure functions: tested in test/linehistory.spec.ts. Counts and dates reuse the Facebook history card's (./fbHistory).
 */
import type { HistoryLink, HistoryRoom, LinkMethod, StaffWho } from '../api/linehistory'
import { fullDate, monthYear, rangeText } from './fbHistory'

export { rangeText }

const fmtCount = new Intl.NumberFormat('th-TH')
/** "1,234 ข้อความ" */
export const countText = (n: number): string => `${fmtCount.format(n)} ข้อความ`

/** "ม.ค. 2567 – ก.ย. 2569" (one month → that month). */
export function spanText(first: string | null, last: string | null): string | null {
  if (!first || !last) return null
  const a = monthYear(first)
  const b = monthYear(last)
  return a === b ? a : `${a} – ${b}`
}

const REASON: Record<LinkMethod, string> = { phone: 'เบอร์โทรตรงกัน', name: 'ชื่อตรงกัน', manual: 'ผูกเอง' }

/** Who made the link: "ผูกโดยระบบ · เบอร์โทรตรงกัน" or "พลอย ยืนยันว่าเป็นคนเดียวกัน · 12 ก.ย. 2569". */
export function linkedByText(l: { method: LinkMethod; decided_by: StaffWho | null; decided_at: string | null }): string {
  if (!l.decided_by) return `ผูกโดยระบบ · ${REASON[l.method]}`
  const at = l.decided_at ? ` · ${fullDate(l.decided_at)}` : ''
  return `${l.decided_by.name} ยืนยันว่าเป็นคนเดียวกัน${at}`
}

/** The question on a suggestion (owner's words for a name match). */
export function suggestTitle(room: Pick<HistoryRoom, 'method'>): string {
  return room.method === 'phone' ? 'ประวัติแชทเก่าที่เบอร์โทรตรงกัน · ใช่คนเดียวกันไหม' : 'ประวัติแชทเก่าที่ชื่อตรงกัน · ใช่คนเดียวกันไหม'
}

/** The export's name of a suggested room ("Unknown" in LINE = no name). */
export function roomName(room: Pick<HistoryRoom, 'name'>): string {
  return room.name?.trim() || 'ไม่มีชื่อในไฟล์ของ LINE'
}

/** Second line of the history room's bar. */
export function barNote(link: HistoryLink | null, span: string | null): string {
  const when = span ? `ข้อความช่วง ${span}` : 'ข้อความก่อนเริ่มใช้ระบบนี้'
  if (!link) return `${when} · ยังไม่ได้ผูกกับลูกค้าในระบบ`
  const who = link.live_name ? `ผูกกับ ${link.live_name}` : 'ผูกกับลูกค้าในระบบแล้ว'
  return `${when} · ${who} (${link.decided_by ? `ยืนยันโดย ${link.decided_by.name}` : `ระบบผูกเพราะ${REASON[link.method]}`})`
}
